/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form[_ngcontent-%COMP%]{width:100vw;height:100vh;display:flex;justify-content:center;align-items:center;flex-direction:column}.form__btn[_ngcontent-%COMP%], .form__textarea[_ngcontent-%COMP%]{outline:0}.form__btn[_ngcontent-%COMP%]{background:#fff;padding:.5rem 1rem;margin:1rem;text-transform:uppercase;opacity:.8;color:#000}.form__btn[_ngcontent-%COMP%]:hover{opacity:1}"];
export { styles as styles };
